module.exports = __webpack_public_path__ + "img/18.d8f860a0.png";